// Google Analytics (GA4) for the official site only.
//
// The measurement ID comes from VUE_APP_GA_MEASUREMENT_ID, which only
// docker-compose.prod.yml passes as a build arg. vue-cli inlines VUE_APP_*
// variables at build time, so on dev.empirecanada.ca (docker-compose.dev.yml,
// which also builds with NODE_ENV=production) and on local runs it is
// undefined: gtag.js is never loaded and no hit leaves the browser.
const MEASUREMENT_ID = process.env.VUE_APP_GA_MEASUREMENT_ID

export default {
  install(app, { router }) {
    if (!MEASUREMENT_ID) return

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag() {
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    // The app is an SPA: GA would only see the first load, so page views are
    // sent manually on every route change instead.
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false })

    router.afterEach((to) => {
      window.gtag('event', 'page_view', {
        page_path: to.fullPath,
        page_location: window.location.origin + to.fullPath,
        page_title: document.title
      })
    })
  }
}
